// ---- Entry point --------------------------------------------------------
// Resolve the initial bracket (shared URL → saved → Elo forecast) and mount.

import { createElement } from "react";
import { createRoot } from "react-dom/client";

import { WorldCupBracket } from "./app.jsx";
import { computeEloForecast } from "./forecast.js";
import { loadSaved } from "./storage.js";
import { parseHash } from "./hash.js";

// Precedence: a shared link wins (you opened it to see that bracket), then your
// own saved picks, then the Elo forecast as a friendly default.
function getInitialState() {
  try {
    const shared = parseHash(window.location.hash);
    if (shared) return { state: shared, note: "Loaded a shared bracket" };
  } catch {
    /* malformed hash — fall through */
  }
  const saved = loadSaved();
  if (saved) return { state: saved, note: "Restored your saved picks" };
  return { state: computeEloForecast(), note: "Prefilled from Elo forecast" };
}

try {
  const { state, note } = getInitialState();
  createRoot(document.getElementById("root")).render(
    createElement(WorldCupBracket, { initialState: state, initialNote: note })
  );
} catch (e) {
  const root = document.getElementById("root");
  root.innerHTML =
    '<div id="boot" class="error"><div>Could not start the bracket.</div>' +
    '<div style="font-size:12px;opacity:.8;max-width:520px">' +
    ((e && e.message) || e) +
    "</div></div>";
  throw e;
}
